import eyelid from './images/eyelid.svg';
import { el, setHidden } from './dom';

/** One eyelid image, mirrored below the eye; menu and subtitle stay above it. */
export class WakeUpOverlay {
  readonly root = el('div', 'wake-up');
  private readonly top = el('img', 'wake-up__lid wake-up__lid--top');
  private readonly bottom = el('img', 'wake-up__lid wake-up__lid--bottom');

  constructor() {
    this.root.setAttribute('aria-hidden', 'true');
    for (const lid of [this.top, this.bottom]) {
      lid.src = eyelid;
      lid.alt = '';
      lid.draggable = false;
      this.root.appendChild(lid);
    }
    setHidden(this.root, true);
  }

  mount(parent: HTMLElement): void { parent.appendChild(this.root); }

  render(visual: { opening: number } | null): void {
    setHidden(this.root, visual === null);
    if (!visual) return;
    const travel = visual.opening * 110;
    this.top.style.transform = `translateY(-${travel}%)`;
    this.bottom.style.transform = `translateY(${travel}%) scaleY(-1)`;
  }
}
